/// <reference types="@types/googlemaps" />

import { Component, OnInit, OnChanges,  SimpleChanges, TemplateRef, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CategoriesService } from 'src/app/categories.service';
import {TranslateService} from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MapsAPILoader } from '@agm/core';
import { ProductsService } from 'src/app/products.service';
// import {} from '@types/googlemaps';
declare let google: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  currentUser = null;
  isAuth:boolean 
  categories
  collapsed = true;
  firstCategory;
  latitude: number =51.673858;
  longitude: number = 7.815982;
  zoom: number = 1;
  address: string;
  private geoCoder;
  @ViewChild('search')
  public searchElementRef: ElementRef;
  modalRef: BsModalRef;
  productInCartCount = 0;
  totalProductInCartPrice =0;

  constructor(private modalService: BsModalService,public authService:AuthService,private categoriesService:CategoriesService,private cookieService:CookieService,private router:Router,private productService:ProductsService) {

  }
 
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }
  
  

  ngOnInit(): void {
    this.getCategories()
    this.getCartInfo()
    
  }
  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }
  logout(){
    this.authService.logout()
    this.router.navigate(['auth/login'])
  }
  getCategories(){
    this.categoriesService.getCategories().subscribe(
      (result)=>{
        this.categories = result
        this.firstCategory = this.categories[0].id;
      }
    )
  }
  getCartInfo(){
    this.productService.getProductsInCart().subscribe(
      (result)=>{
        this.productInCartCount = result.order_details.length
        this.totalProductInCartPrice = result.cost
        console.log(result)
      }
    )
  }
  

 
}
